export default class zolaGa {
  constructor() {
    // Bind methods.
    this.processLineItem = this.processLineItem.bind(this);
    this.receiveMessage = this.receiveMessage.bind(this);
    this.init = this.init.bind(this);

    // Set up transactionProducts array.
    this.transactionProducts = [];
  }

  init() {
    // Add event listener for message event sent from Zola iframe.
    window.addEventListener('message', this.receiveMessage, false);
  }

  /**
   * Process individual shopping items sold, adding them to the transactionProducts array.
   *
   * @param lineItem
   */
  processLineItem(lineItem) {
    // Build a single product.
    const transactionProduct = {
      sku: lineItem.book.isbn,
      name: lineItem.book.title,
      category: lineItem.book.form,
      price: lineItem.price_per_unit,
      quantity: lineItem.quantity,
    };

    // Add the product to the transactionProducts array.
    this.transactionProducts.push(transactionProduct);
  }

  /**
   * Process the 'message' event.
   *
   * @param event
   * @returns {*}
   */
  receiveMessage(event) {
    // If there's no data or data is not json, it's not a zola request.
    let data = {};
    try {
      data = JSON.parse(event.data);
    } catch (e) {
      return false;
    }

    // Make sure it's a zola order.
    if ('undefined' === typeof data.order_id) {
      return false;
    }

    // Reset the transactionProducts array.
    this.transactionProducts = [];

    // Add each product from event.data to the transactionProducts array.
    if ('undefined' !== typeof data.line_items) {
      data.line_items.forEach(this.processLineItem);
    }

    // Build the full object to be sent to GA tracker.
    const dataLayer = {
      event: 'transaction',
      transactionId: data.order_id,
      transactionAffiliation: data.store_uid,
      transactionTotal: data.total,
      transactionTax: data.tax_total,
      transactionShipping: data.shipping_total,
      transactionProducts: this.transactionProducts,
    };

    // If we're on staging, then dump the data for review.
    if ('https://widget-staging.zo.la' === event.origin) {
      // eslint-disable-next-line no-console
      console.log('dataLayer sent to GA', dataLayer);
    }

    // If we're on production, send the data to GA.
    if ('https://widget.zo.la' === event.origin) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayer);
    }

    return 1;
  }
}
